import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconRainyLight: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="rainy-light"><path d="M11.25 15.75L10.25 17.75M13.5 18.5L12.5 20.5M9.42188 15.25H16.125C18.4032 15.25 20.25 13.3777 20.25 11.0682C20.25 8.75863 18.4032 6.88636 16.125 6.88636C15.5908 6.88636 15.0803 6.98932 14.6117 7.17673C13.7313 5.15838 11.7388 3.75 9.42188 3.75C6.28939 3.75 3.75 6.32436 3.75 9.5C3.75 12.6756 6.28939 15.25 9.42188 15.25Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/></CentralIconBase>;
};

export default IconRainyLight;
